module.exports = __webpack_public_path__ + "static/PP1s-10368d022026cac8af03483702d296c0.jpg";